import { render, staticRenderFns } from "./PembinaanSection.vue?vue&type=template&id=bd32fa8c"
import script from "./PembinaanSection.vue?vue&type=script&lang=js"
export * from "./PembinaanSection.vue?vue&type=script&lang=js"
import style0 from "./PembinaanSection.vue?vue&type=style&index=0&id=bd32fa8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports